import React from 'react';
import Header from './components/Header';
import Hero from './components/Hero';
import Services from './components/Services';
import PropertySearch from './components/PropertySearch';
import About from './components/About';
import Contact from './components/Contact';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';
import './App.css';

function App() {
  return (
    <div className="App">
      <Header />
      <Hero />
      <Services />
      <PropertySearch />
      <About />
      <Contact />
      <Footer />
      <ScrollToTop />
    </div>
  );
}

export default App;
